import styled from "styled-components";
import theme from "~/styles/theme";

export const ContentModal = styled.div`
  cursor: default;
  text-align: center;

  .title {
    color: ${theme.palette.brand.primary.key};
    font-size: 24px;
    font-weight: 700;
  }

  .description {
    color: ${theme.palette.neutral.primary.key};
    width: 320px;
    margin: 0 auto;
    font-weight: 500;
    font-size: 16px;
  }

  .text {
    color: ${theme.palette.neutral.primary.key};
    max-width: 440px;
    margin: 0 auto;
    font-size: 16px;
  }

  button {
    width: 270px;
    font-size: 16px;
  }
`;
